/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

function RefinanciamentoVeiculosRedirect({ posts, categories }) {
  const router = useRouter();
  useEffect(() => {
    router.replace(
      `/blog/renegociacao-de-veiculos-saiba-tudo-o-que-voce-precisa.html${window.location.search}`,
    );
  }, []);
  return <>{/*  */}</>;
}

export const config = {
  amp: false,
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default RefinanciamentoVeiculosRedirect;
